import React , {useState} from 'react'


export default function About(props) {
   
   
    //const [stl,setstyle]=useState({
        //color:'white',
        //backgroundColor:'black'
        
   // })
    //const [btntext,changetext]=useState("Enable Dark mode")
 
 {/* let  clk=()=>{
        if(stl.color==='white'){
            setstyle({
                color:'black',
                backgroundColor:'white',
                border:'2px solid black'
                
            })
            changetext("Enable Light mode")
        }else {
            setstyle({
                color:'white',
                backgroundColor:'black',
                border:'2px solid white'
                
            })
            changetext("Enable Dark mode")
        }
    }*/}

    let stl ={
      color:props.mode==='dark'?'white':'black',
      backgroundColor:props.mode==='dark'?'gray':'white',
      border:'2px solid',
      borderColor:props.mode==='dark'?'white':'black'

    }
     
  return (
    
    
<div className="container" >
    <h2 className="my-3">About us</h2>
<div className="accordion" id="accordionExample" >
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style={stl}>
        📌 Conclusion
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
      <div className="accordion-body" style={stl}>
        TextUtil is a practical and efficient tool for anyone who needs quick text formatting capabilities in a browser-based environment. Its clean design and responsive functionality make it ideal for everyday use. By leveraging React.js, the app ensures smooth performance and scalability, making it a great addition to your portfolio or a stepping stone for more advanced web applications.

          <br/>If you're planning to expand it, consider adding features like:<br/>
          Word/character count<br/>
          Dark/light mode toggle<br/>
          Counts the word Present in the Paragraph <br/>
          Counts the Charecters Present in the Paragraph <br/>
          Time Count for Reading The particular Paragraph<br/>
          
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" style={stl}>
        ✨ Key Features
      </button>
    </h2>
    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body" style={stl}>
     🔠 Convert to Uppercase – Instantly transform all text to uppercase. <br/><hr/>

🔡 Convert to Lowercase – Quickly change all text to lowercase. <br/><hr/>

📋 Copy Text – Copy the entire content to clipboard with a single click. <br/><hr/>

🧹 Clear Text – Remove all text from the input area. <br/><hr/>

❌ Remove Written Text – Erase specific or all content as needed. <br/><hr/>

These features are designed to streamline text editing tasks, especially for writers, developers, and students who frequently work with raw text.<br/>  
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" style={stl}>
        🛠️ Technologies Used
      </button>
    </h2>
    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body" style={stl}>
        
        React.js--	Frontend framework for building UI components <br/> <hr/>
JavaScript--	Logic for text manipulation and interactivity <br/> <hr/>
HTML/CSS --	Structuring and styling the user interface <br/> <hr/>
Bootstrap --	For responsive design and layout  <br/> <hr/>
      </div>
    </div>
  </div>
  {/*<button type='button' className='btn btn-primary my-3' onClick={clk}  >{btntext}</button>*/}
</div>
</div>
    
  )
}
